import { combineReducers } from 'redux'
import newsfeed from './newsfeed'
import banking from './banking'
import bookkeepingaccountingrecords from './bookkeepingaccountingrecords'
import dashboard from './dashboard'
import project from './project'
import offer from './offer'
import customer from './customer'
import customerIssues from './customerIssues'
import client from './client'
import supplier from './supplier'
import article from './article'
import expense from './expense'
import listContextMenu from './listContextMenu'
import modal from './modal'
import subscription from './subscription'
import settings from './settings'
import menu from './menu'
import documentExport from './documentExport'
import bookingSelection from './bookingSelection'
import taxCategories from './taxCategories'
import revenue from './revenue'
import chartOfAccounts from './chartOfAccounts'
import global from './global'
import document from './document'
import user from './user'
import tenant from './tenant'
import onboarding from './onboarding'
import moduleContext from './moduleContext'
import vatReturn from './vatReturn'
import taxForms from './taxForms'
import search from './search'
import apps from './apps'
import shipping from './shipping'
import lists from './lists'
import businessPartner from './businessPartner'
import email from './email'
import todo from './todo'
import permission from './permission'
import wizard from './wizard'
import collaboration from './collaboration'
import economicAsset from './economicAsset'
import signature from './signature'
import receipt from './receipt'
import worker from './worker'
import upgrade from './upgrade'
import ai from './ai'
import tenantUser from './tenantUser'
import buhlArchiv from './buhlArchiv'

// sort for redux dev tools ;)
const appReducer = combineReducers({
  ai,
  apps,
  article,
  banking,
  bookingSelection,
  bookkeepingaccountingrecords,
  businessPartner,
  chartOfAccounts,
  // cleverreach,
  client,
  collaboration,
  customer,
  customerIssues,
  dashboard,
  document,
  documentExport,
  economicAsset,
  email,
  expense,
  global,
  listContextMenu,
  lists,
  menu,
  modal,
  moduleContext,
  newsfeed,
  offer,
  onboarding,
  permission,
  project,
  revenue,
  search,
  settings,
  shipping,
  subscription,
  supplier,
  taxCategories,
  taxForms,
  tenant,
  todo,
  user,
  vatReturn,
  wizard,
  signature,
  receipt,
  worker,
  upgrade,
  tenantUser,
  buhlArchiv,
})

export type AppStateType = ReturnType<typeof appReducer>;
export default appReducer
